import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getInsuranceItemsView from 'checkout/selectors/view/itemViews/getInsuranceItemsView'
import getLoyaltyInsuranceProductType from 'loyalty/lib/getLoyaltyInsuranceProductType'

const getCheckoutInsurancePointsCalculationRequests = createSelector(
  (state: App.State) => getInsuranceItemsView(state),
  (insuranceItemsView): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!insuranceItemsView.hasRequiredData) return EmptyArray

    return insuranceItemsView.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => ({
      price: itemView.totals.price,
      memberPrice: itemView.totals.memberPrice,
      loyaltyProductType: getLoyaltyInsuranceProductType(itemView.item.insuranceType),
      itemId: itemView.item.itemId,
    }))
  },
)

export default getCheckoutInsurancePointsCalculationRequests
